import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import { RequirePermission } from '@/features/auth/guards';
import { NotFoundPage } from '@/pages/not-found-page';

const List = lazy(() => import('./pages/products-list-page').then((m) => ({ default: m.ProductsListPage })));
const FormPage = lazy(() => import('./pages/product-form-page').then((m) => ({ default: m.ProductFormPage })));
const ImportPage = lazy(() => import('./pages/import-page').then((m) => ({ default: m.ImportPage })));
const LabelsPage = lazy(() => import('./pages/labels-page').then((m) => ({ default: m.LabelsPage })));
const CatalogPage = lazy(() => import('./pages/catalog-page').then((m) => ({ default: m.CatalogPage })));

const fallback = (
  <div role="status" aria-label="Carregando" className="flex flex-col gap-3">
    {Array.from({ length: 4 }, (_, i) => (
      <div key={i} aria-hidden className="skeleton h-12 w-full" />
    ))}
  </div>
);

/** Rotas do módulo de produtos (montadas em `produtos/*`; a permissão de leitura fica em app/routes.tsx). */
export function ProductsRoutes() {
  return (
    <Suspense fallback={fallback}>
      <Routes>
        <Route index element={<List />} />
        <Route path="novo" element={<RequirePermission permission="products.write" children={<FormPage mode="new" />} />} />
        <Route path="importar" element={<RequirePermission permission="products.write" children={<ImportPage />} />} />
        <Route path="etiquetas" element={<LabelsPage />} />
        <Route path="categorias" element={<CatalogPage />} />
        <Route path=":id" element={<FormPage mode="edit" />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
